var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0003 14.0001C22.7387 12.2967 24.5003 10.2551 24.5003 7.58341C24.5003 5.88161 23.8243 4.2495 22.6209 3.04615C21.4176 1.84279 19.7855 1.16675 18.0837 1.16675C16.0303 1.16675 14.5837 1.75008 12.8337 3.50008C11.0837 1.75008 9.63699 1.16675 7.58366 1.16675C5.88185 1.16675 4.24975 1.84279 3.04639 3.04615C1.84303 4.2495 1.16699 5.88161 1.16699 7.58341C1.16699 10.2667 2.91699 12.3084 4.66699 14.0001L12.8337 22.1667L21.0003 14.0001Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassion);
export default __webpack_public_path__ + "static/media/passion.f055deacdfce6d41e6d18046c927816b.svg";
export { ForwardRef as ReactComponent };